import { ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER_ADMIN } from '../../constants/roles';
import { createHasSessionAccessSelector } from '../session';

export const selectCanAccessUsers = createHasSessionAccessSelector([ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER_ADMIN]);
export const selectCanAccessCreditUsageReport = createHasSessionAccessSelector([ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER_ADMIN]);